<template>
  <!-- @click.capture.native="setBreadCrumpProduct(banner)" -->
  <div
    v-if="banner && banner.picture"
    :class="fullWidth ? 'w-100' : 'home-banner-holder'"
  >
    <DynamicLinker class="d-flex" v-if="banner" :item="banner">
      <img
        loading="lazy"
        :src="banner.picture"
        class="w-100"
        :alt="banner.position_description"
      />
    </DynamicLinker>
  </div>
  <Skeleton v-else></Skeleton>
</template>

<script>
import DynamicLinker from "@/parts/Front/components/shared/DynamicLinker";
import findUrl from "@/libraries/links/LinkResolver";

export default {
  name: "HomeBanner",
  components: { DynamicLinker },
  props: {
    banner: Object,
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  // methods: {
  //   setBreadCrumpProduct(data) {
  //     let url = this.findUrl(
  //       data.linkable_type,
  //       data.linkable_id,
  //       data.slug,
  //       data.link,
  //     );
  //     console.log(url, "urlurlurl");

  //     // let breadCrump = {
  //     //   isHome: true,
  //     //   list: [
  //     //     {
  //     //       title: "بنر",
  //     //       link: this.$router.resolve(
  //     //         findUrl(
  //     //           data.linkable_type,
  //     //           data.linkable_id,
  //     //           data.slug,
  //     //           data.link,
  //     //         ),
  //     //       ).href,
  //     //     },
  //     //     { title: product.title, link: null },
  //     //   ],
  //     // };
  //     // sessionStorage.setItem(
  //     //   "bread_crump_product_detail",
  //     //   JSON.stringify(breadCrump),
  //     // );
  //     // console.log(
  //     //   JSON.parse(sessionStorage.getItem("bread_crump_product_detail")),
  //     // );
  //   },
  //   findUrl,
  // },
};
</script>
<style scoped>
.Skeleton {
  height: 300px;
}
.home-banner-holder {
  width: 49%;
}
@media screen and (max-width: 769px) {
  .home-banner-holder {
    width: 100%;
  }
  .Skeleton {
    height: 150px;
  }
}
</style>
